module.exports = __webpack_public_path__ + "img/thumbnail-header-14.7d758fb.jpeg";